// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgKitchenAppliancesIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-4 14H4V6h12zm3-6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M6 9c0-.55.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1" />
  </g>
);
export default SvgKitchenAppliancesIcon;
SvgKitchenAppliancesIcon.displayName = 'SvgKitchenAppliancesIcon';
